import httpClient from './httpClient';

const END_POINT = '/api/phone/verify';

const sendVerificationCode = (phone, phoneNumberCode) => httpClient.post(
    END_POINT,
    {
        phone,
        phoneNumberCode
    });

export {
    sendVerificationCode
}
